export default __webpack_public_path__ + "static/media/arrow-back-white.dfa87361.svg";